module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("j6z8i"))).then(() => parcelRequire('cVugQ'));